import { TooltipTrigger } from 'react-aria-components';

import {
  DETAILS_TOOLBAR_SLOTS,
  TextButton,
  TOAST_TIMEOUT,
  Tooltip,
  useCopyToClipboard,
} from '@/libs/serenity-ui';
import { Route } from '@/routes/_main';

interface CopyIdToolbarTextButtonProps {
  id: number | string;
}

export function CopyIdToolbarTextButton(props: CopyIdToolbarTextButtonProps) {
  const routeContext = Route.useRouteContext();

  const [ , copyToClipboard ] = useCopyToClipboard();

  return (
    <TooltipTrigger>
      <TextButton
        slot={DETAILS_TOOLBAR_SLOTS.COPY_ID_TEXT_BUTTON}
        onPress={() => void copyToClipboard(props.id.toString()).then(() => routeContext.toastQueue.add({ message: 'Copied to clipboard', variant: 'success' }, { timeout: TOAST_TIMEOUT }))}>
        {props.id}
      </TextButton>
      <Tooltip placement="bottom">Copy ID</Tooltip>
    </TooltipTrigger>
  );
}
